import {FoodNutrientType} from "./_types";

export const EMPTY_FOOD_NUTRIENT: FoodNutrientType = {
    count: 0,
    nutrient: null,
    id: ''
};

